import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'

const service = new ApolloClientService()

// Thin wrapper around the coded-reminders GraphQL API (mirrors settings.service.js).
export default class Reminders {
  _call(method, params) {
    return new Promise((resolve, reject) => {
      service[method](params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) resolve(data)
          else reject({ ...(data || {}), error: true })
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  remindersForCompany = (params) => this._call('remindersForCompany', params)
  remindersForClinic = (params) => this._call('remindersForClinic', params)
  upsertCompanyReminder = (params) => this._call('upsertCompanyReminder', params)
  deleteCompanyReminder = (params) => this._call('deleteCompanyReminder', params)
  upsertClinicReminder = (params) => this._call('upsertClinicReminder', params)
  deleteClinicReminder = (params) => this._call('deleteClinicReminder', params)
  resetClinicReminders = (params) => this._call('resetClinicReminders', params)
}
